var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { Box3, BoxGeometry, Mesh, MeshBasicMaterial } from "three";
import { AnimationDirection } from "../animations";
import { EPSILON } from "../config";
export function instantlyChangeState(stateId, preview) {
  return __awaiter(this, void 0, void 0, function* () {
    // Create a state with a near zero duration
    const statePromise = preview.transitionState(stateId, {
      duration: EPSILON
    });
    // Update animation by one second to assure it finishes
    preview.updateAnimations(1);
    // Wait for the state to finish (instantaneously)
    yield statePromise;
  });
}
export function instantlyPlayAnimation(animationId, product) {
  return __awaiter(this, void 0, void 0, function* () {
    // Build an animation with near zero duration
    const animation = product.buildAnimation({
      animationId,
      direction: AnimationDirection.forward,
      duration: EPSILON
    });
    const animationPromise = animation.start();
    // Update animation by one second to assure it finishes
    animation.update(1);
    // Wait for the animation to finish (instantaneously)
    yield animationPromise;
  });
}
export function getStateBounds(preview, product, geometry, normalizationFactor) {
  return __awaiter(this, void 0, void 0, function* () {
    const stateBounds = {};
    const initialStateId = product.getCurrentState().id;
    const productStates = product.getStates();
    // Find the bounds for each state
    // NOTE: needs to run async to prevent conflict as it modifies the same object
    for (const state of productStates) {
      if (state.boundingBox) {
        const box = buildBoundingBoxGeometry(state.boundingBox, normalizationFactor);
        stateBounds[state.id] = new Box3().setFromObject(box);
      } else {
        yield instantlyChangeState(state.id, preview);
        stateBounds[state.id] = new Box3().setFromObject(geometry);
      }
    }
    // Reset the model to its initial state before finishing
    yield instantlyChangeState(initialStateId, preview);
    return stateBounds;
  });
}
export function buildBoundingBoxGeometry(boundingBox, scaleFactor) {
  // calculate dimensions of the bounding box
  const width = boundingBox.max.x - boundingBox.min.x;
  const height = boundingBox.max.y - boundingBox.min.y;
  const depth = boundingBox.max.z - boundingBox.min.z;
  // calculate center point position of bounding box
  const x = (boundingBox.max.x + boundingBox.min.x) / 2.0;
  const y = (boundingBox.max.y + boundingBox.min.y) / 2.0;
  const z = (boundingBox.max.z + boundingBox.min.z) / 2.0;
  // create box geometry and translate to correct position
  // as BoxGeometry is created with its center at the origin
  const boundingBoxGeometry = new BoxGeometry(width, height, depth);
  boundingBoxGeometry.translate(x, y, z);
  const material = new MeshBasicMaterial({
    color: 0x00ff00
  });
  const box = new Mesh(boundingBoxGeometry, material);
  if (scaleFactor) {
    // Scale and position the geometry based on the scaleFactor
    box.scale.multiplyScalar(scaleFactor);
    box.position.multiplyScalar(scaleFactor);
  }
  return box;
}